window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.view_project_group_modal = window.locales.am.view_project_group_modal || {};window.locales.am.view_project_group_modal = {...window.locales.am.view_project_group_modal, ...{
    "title": "የአንተ የፕሮጀክት ቡድን",
    "api_error": "የሆነ ችግር ፈጠረ። እባኮትን እንደገና ሞክር።"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.view_project_group_modal = window.locales.ar.view_project_group_modal || {};window.locales.ar.view_project_group_modal = {...window.locales.ar.view_project_group_modal, ...{
    "title": "فريق المشروع الخاص بك",
    "api_error": "حدث خطأ. يرجى المحاولة مرة أخرى."
}
};window.locales.en = window.locales.en || {};window.locales.en.view_project_group_modal = window.locales.en.view_project_group_modal || {};window.locales.en.view_project_group_modal = {...window.locales.en.view_project_group_modal, ...{
    "title": "Your Project Team",
    "api_error": "Something went wrong. Please try again."
}
};window.locales.es = window.locales.es || {};window.locales.es.view_project_group_modal = window.locales.es.view_project_group_modal || {};window.locales.es.view_project_group_modal = {...window.locales.es.view_project_group_modal, ...{
    "title": "Tu Equipo de Proyecto",
    "api_error": "Algo salió mal. Inténtalo de nuevo."
}
};window.locales.it = window.locales.it || {};window.locales.it.view_project_group_modal = window.locales.it.view_project_group_modal || {};window.locales.it.view_project_group_modal = {...window.locales.it.view_project_group_modal, ...{
    "title": "Il Tuo Team di Progetto",
    "api_error": "Qualcosa è andato storto. Riprova."
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.view_project_group_modal = window.locales.zh.view_project_group_modal || {};window.locales.zh.view_project_group_modal = {...window.locales.zh.view_project_group_modal, ...{
    "title": "您的项目团队",
    "api_error": "出了点问题。请再试一次。"
}
};